/**
 * Module dependencies.
 */

import { Link } from 'components/atoms/link/link';
import { Menu, MenuItem } from '@mui/material';
import styled from '@emotion/styled';

/**
 * Export `NavBarMenu` styled component.
 */

export const NavBarMenu = styled(Menu)`
  @media (max-width: 768px) {
    display: none;
    flex-direction: column;
    width: 100%;
    background: #222;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 16px;
    z-index: 2000;

    &.open {
      display: flex;
    }
  }
`;

/**
 * Export `StyledLink` styled component.
 */

export const StyledLink = styled(Link)`
  color: white;
  font-size: 30px;
`;

/**
 * Export `StyledMenuItem` styled component.
 */

export const StyledMenuItem = styled(MenuItem)`
  font-size: 40px;
  font-weight: 200;
  font-family: 'Inter', sans-serif;

  @media (max-width: 576px) {
    font-size: 25px;
    padding: 5px 8px;
  }
`;
